const HEADER_SECURITY_ERROR_MESSAGE = 'Security: Header value contains invalid characters';
const INTERCEPTOR_FLAG = '__vendysHeaderValidationInterceptorInstalled';
const METHOD_HEADER_KEYS = ['delete', 'get', 'head', 'options', 'post', 'put', 'patch', 'common'];

const hasInvalidHeaderValue = (value) => {
  if (typeof value === 'undefined' || value === null) {
    return false;
  }

  if (Array.isArray(value)) {
    return value.some(hasInvalidHeaderValue);
  }

  return /[\r\n]/.test(String(value));
};

const isHeaderMap = (value) => {
  return value && typeof value === 'object' && !Array.isArray(value);
};

export const getMergedHeaders = (headers = {}, method = 'get') => {
  if (!isHeaderMap(headers)) {
    return {};
  }

  const normalizedMethod = typeof method === 'string' ? method.toLowerCase() : 'get';
  const mergedHeaders = {};
  const headerGroups = [];

  if (isHeaderMap(headers.common)) {
    headerGroups.push(headers.common);
  }

  if (normalizedMethod && isHeaderMap(headers[normalizedMethod])) {
    headerGroups.push(headers[normalizedMethod]);
  }

  headerGroups.push(headers);

  headerGroups.forEach((group) => {
    Object.keys(group).forEach((key) => {
      if (METHOD_HEADER_KEYS.indexOf(key) > -1) {
        return;
      }

      mergedHeaders[key] = group[key];
    });
  });

  return mergedHeaders;
};

export const validateHeaderValues = (headers = {}) => {
  Object.keys(headers).forEach((key) => {
    if (hasInvalidHeaderValue(headers[key])) {
      throw new Error(HEADER_SECURITY_ERROR_MESSAGE);
    }
  });
};

export const validateAxiosHeaderConfig = (config = {}) => {
  validateHeaderValues(getMergedHeaders(config.headers, config.method));
  return config;
};

export const installAxiosHeaderValidation = (axiosInstance) => {
  if (!axiosInstance || !axiosInstance.interceptors || !axiosInstance.interceptors.request) {
    return axiosInstance;
  }

  if (axiosInstance[INTERCEPTOR_FLAG]) {
    return axiosInstance;
  }

  axiosInstance[INTERCEPTOR_FLAG] = true;
  axiosInstance.interceptors.request.use((config) => validateAxiosHeaderConfig(config));

  return axiosInstance;
};

export { HEADER_SECURITY_ERROR_MESSAGE };
